import { FEATURE_IDS } from "../constants/featureAccess";

/** Team plan IDs that support paid staff (Team, Business, Scale). */
export const TEAM_PLAN_IDS = [4, 5, 6];

/**
 * Same gate as Invite User on manage-subscription:
 * paid active organization (team) subscription required.
 */
export const canUseOrganizationStaff = (userPlan) => {
  const planId = parseInt(userPlan?.plan_id, 10);
  return (
    userPlan?.plan_type === "team" &&
    userPlan?.is_paid_subscription === "E" &&
    TEAM_PLAN_IDS.includes(planId)
  );
};

export const hasPooledAvailability = (features) => {
  if (!features || !Array.isArray(features)) {
    return false;
  }

  const feature = features.find(
    (f) => f.feature_id === FEATURE_IDS.POOLED_AVAILABILITY
  );
  return feature ? feature.status === "E" : false;
};

/**
 * Force "My Event" staff assignment when staff features are unavailable.
 * Strip pooled assignment options when Pooled Availability is not on the plan.
 */
export const normalizeStaffAssignmentPayload = (data, userPlan, features = []) => {
  if (!canUseOrganizationStaff(userPlan)) {
    return {
      ...data,
      staff_assignment_type: "1",
      staff_choose: "",
      staff_assignment_method: "",
      staffs: [],
    };
  }

  if (!hasPooledAvailability(features)) {
    const normalized = { ...data };
    if (normalized.staff_choose === "random_choose") {
      normalized.staff_choose = "";
    }
    normalized.staff_assignment_method = "";
    return normalized;
  }

  return data;
};
